import { render, staticRenderFns } from "./agogis-toggle-selection.vue?vue&type=template&id=4ed9c977"
import script from "./agogis-toggle-selection.vue?vue&type=script&lang=ts"
export * from "./agogis-toggle-selection.vue?vue&type=script&lang=ts"
import style0 from "./agogis-toggle-selection.vue?vue&type=style&index=0&id=4ed9c977&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports